<template>
    <AppModal ref="modal" :title="$t('labels.products_filters')">
        <div class="modal-body">
            <table class="table table-bordered table-fixed">
                <thead>
                    <tr>
                        <th width="50%">{{ $t('labels.field') }}</th>
                        <th width="50%">{{ $t('labels.action') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="field in fields" :key="field.key">
                        <td>{{ field.label }}</td>
                        <td>
                            <AppSelect
                                :options="getActionOptionsByField(field.key)"
                                :model-value="field.selectedAction?.key"
                                :selected-value="field.selectedAction?.label"
                                @update:model-value="selectAction(field, $event)"
                                option-key="key"
                                option-value="label"
                                can-be-empty
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer">
            <AppButton size="sm" @click="apply" color="teal">{{ $t('buttons.apply') }}</AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import AppSelect from '../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

export default {
    name: "ProductsFiltersModal",
    components: {
        AppModal, AppSelect, AppButton
    },
    emits: ['update:filters'],
    data() {
        return {
            fields: [
                { key: 'diff_amount_is_negative', label: this.$t('labels.balance_sufficient'), selectedAction: null, value: null },
            ],
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        clear() {
            this.fields.forEach(field => {
                field.selectedAction = null;
                field.value = null;
            });
            this.$emit('update:filters', {}, 0);
        },
        getActionOptionsByField(field) {
            let options = [];

            if (field === 'diff_amount_is_negative') {
                options = [
                    { key: 'yes', label: this.$t('labels.yes') },
                    { key: 'no', label: this.$t('labels.no') },
                ]
            }

            return options;
        },
        selectAction(field, action) {
            if (field.key === 'diff_amount_is_negative') {
                if (action?.key === 'no') {
                    field.value = 1;
                } else if (action?.key === 'yes') {
                    field.value = 0;
                } else {
                    field.value = null;
                }
            } else {
                field.value = null;
            }

            field.selectedAction = action;
        },
        apply() {
            this.$emit('update:filters')
            this.$refs.modal.hide()
        },
    }
}
</script>
